import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoginDetail } from 'src/app/models/auth.model';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  oldPassIncorrect: boolean = false;
  passReset: boolean = false;

  constructor(private http: HttpService, private auth: AuthService) { }

  ngOnInit() {
  }

  onResetPassword(form: NgForm) {
    this.http.resetPassword(form.value.oldpass, form.value.newpass).subscribe(
      (detail: LoginDetail) => {
        // re-login to store the new token
        this.auth.login(this.auth.user, detail.client, detail.token);
        this.oldPassIncorrect = false;
        this.passReset = true;
      },
      (error) => {
        this.oldPassIncorrect = true;
        this.passReset = false;
      }
    )


  }

}
